import BaseController from "niteroi/packages/system/controllers/Base.controller";
import {SharedServices} from "niteroi/services/SharedServices";
import UIComponent from "sap/ui/core/UIComponent";
import Input from "sap/m/Input";
import TextArea from "sap/m/TextArea";
import Validation from "niteroi/packages/system/helpers/Validation";
import {ILoadDataResponse} from "niteroi/packages/system/models/interfaces";

export default class Contact extends BaseController {
    public onInit(): void {
        super.onInit();
        SharedServices.updateTheme(this.getOwnerComponent() as UIComponent);
    }

    public onBeforeRendering() {
        super.onBeforeRendering();
    }

    protected validateContactForm(): boolean {
        const firstNameElement = this.byId("niteroiContactInputFirstName") as Input;
        const lastNameElement = this.byId("niteroiContactInputLastName") as Input;
        const emailElement = this.byId("niteroiContactInputEmail") as Input;
        const messageElement = this.byId("niteroiContactTextAreaMessage") as TextArea;

        if (!firstNameElement.getValue()) {
            firstNameElement.setValueState("Error");
            return false;
        } else {
            firstNameElement.setValueState("None");
        }

        if (!lastNameElement.getValue()) {
            lastNameElement.setValueState("Error");
            return false;
        } else {
            lastNameElement.setValueState("None");
        }

        if (!emailElement.getValue() || !Validation.isValidEmail(emailElement.getValue())) {
            emailElement.setValueState("Error");
            return false;
        } else {
            emailElement.setValueState("None");
        }

        if (!messageElement.getValue()) {
            messageElement.setValueState("Error");
            return false;
        } else {
            messageElement.setValueState("None");
        }

        return true;
    }

    public onSubmitContactForm(): void {
        const firstName = (this.byId("niteroiContactInputFirstName") as Input).getValue();
        const lastName = (this.byId("niteroiContactInputLastName") as Input).getValue();
        const email = (this.byId("niteroiContactInputEmail") as Input).getValue();
        const text = (this.byId("niteroiContactTextAreaMessage") as TextArea).getValue();

        if (this.validateContactForm()) {
            this.getView().setBusyIndicatorDelay(0).setBusy(true);
            const settingsModel = this.getModel("settings");
            const systemOwner = settingsModel.getProperty("/systemOwner") as string;
            const toFirstName = this.getText("companyName");
            const toLastName = this.getText("appTitle");
            const title = `${this.getText("companyName")} - ${this.getText("appTitle")}, ${this.getText("sayHello")}`
            const requestBody = {
                title,
                "fromFirstName": firstName,
                "fromLastName": lastName,
                "fromEmail": email,
                "toFirstName": toFirstName,
                "toLastName": toLastName,
                "toEmail": systemOwner,
                "message": text
            }

            const contactModel = this.createRequestModel();
            const headers = this.getRequestHeaders();
            const url = "/api/customer-services/tickets";
            contactModel.loadData(
                url,
                JSON.stringify(requestBody),
                true,
                "POST",
                true,
                undefined,
                headers
            ).then(() => {
                this.showToast(this.getText("contactPageFormConfirmation"));
                (this.byId("niteroiContactInputFirstName") as Input).setValue("");
                (this.byId("niteroiContactInputLastName") as Input).setValue("");
                (this.byId("niteroiContactInputEmail") as Input).setValue("");
                (this.byId("niteroiContactTextAreaMessage") as TextArea).setValue("");
            }).catch((response: ILoadDataResponse) => {
                const responseText = JSON.parse(response.responseText);
                this.showToast(`${responseText.code} - ${responseText.error}`);
            }).finally(() => {
                this.getView().setBusy(false).setBusyIndicatorDelay(1000);
            });
        }
    }
}
